import { memo, useMemo, useRef } from 'react'
import { createPortal } from 'react-dom'

export const useInfoWindowPortal = () => {
  const containerRef = useRef(document.createElement('div'))
  const InfoWindow = useMemo(
    () =>
      memo(({ children }) => {
        return createPortal(children, containerRef.current)
      }),
    []
  )

  return { InfoWindow, containerRef }
}
